import { handleLoopOver } from './carousel-utils';
let startX = 0;
let endX = 0;
let startSwiped = 0;
let leftSwipe = true;
let startY = 0;
const minScrollVerticalThreshold = 10;


export const handleSwipe = (e, $this) => {
  if (Math.abs(_getVerticalSwipeValue(e) - startY) < minScrollVerticalThreshold && e.cancelable) {
    e.preventDefault();
  }

  if ($this.isSwiping) {
    let currentSwipeVal = 0;
    currentSwipeVal = _getCurrentSwipeValue(e);
    const val = currentSwipeVal - startX;
    $this.translateVal = Math.abs(startSwiped) > 0 ? startSwiped + val : val;
    $this.swiped = $this.translateVal;
  }
};

export const handleSwipeCancel = (_, $this) => {
  $this.isSwiping = false;
};

export const handleSwipeEnd = (e, $this) => {
  if (Math.floor(e.clientX) === Math.floor(startX)) $this.isSwiping = false;

  if ($this.isSwiping) {
    _isLeftSwipe(e, $this);
    if (leftSwipe) {
      if (!(Math.abs($this.swiped) >= $this.scrollableWidth)) {
        $this.currentIndex++;
      }
      $this.swiped = $this.scrollVals[$this.currentIndex];
      $this.scrollState = $this.swiped;
      if ($this.loop && $this.currentIndex === $this.eachSideClone + $this.numItems) {
        setTimeout(() => handleLoopOver($this), 350);
      }
    } else {
      if ($this.currentIndex != 0) {
        $this.currentIndex--;
      }
      $this.swiped = $this.scrollVals[$this.currentIndex];
      $this.scrollState = $this.swiped;
      if ($this.loop && $this.currentIndex === $this.eachSideClone - 1) {
        setTimeout(() => handleLoopOver($this), 350);
      }
    }
    $this.isSwiping = false;
  }
};

export const handleSwipeStart = (e, $this) => {
  if ($this.loop && Math.floor($this.carouselList.scrollLeft) === $this.scrollableWidth) {
    return;
  }
  startY = _getVerticalSwipeValue(e);
  startX = _getCurrentSwipeValue(e);
  startSwiped = $this.swiped;
  $this.isSwiping = true;
};

const _getCurrentSwipeValue = e => {
  let cSwipeVal = 0;
  if (e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchstart') {
    const touches = e.touches;
    cSwipeVal = touches[0].clientX;
  } else {
    cSwipeVal = e.x;
  }
  return cSwipeVal;
};

function _isLeftSwipe(e: any, $this: any) {
  if (e.type === 'touchend') {
    endX = e.changedTouches[0].clientX;
    leftSwipe = endX - startX > 0 ? false : true;
  } else {
    leftSwipe = e.x - startX > 0 ? false : true;
  }
  if ($this.docDirFactor == -1) {
    leftSwipe = !leftSwipe;
  }
}

const _getVerticalSwipeValue = e => {
  let vSwipeVal = 0;
  if (e.type === 'touchmove' || e.type === 'touchend' || e.type === 'touchstart') {
    const touches = e.touches;
    vSwipeVal = touches[0].clientY;
  } else {
    vSwipeVal = e.y;
  }
  return vSwipeVal;
};
